import React from 'react';

import './TaskHeader.scss';

export default function TaskHeader({ children }) {
  return <div className="etc-header">{children}</div>;
}
